var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-select-cell",style:(_vm.style)},[_c('BBPSelect',{attrs:{"options":_vm.options,"placeholder":_vm.placeholder,"label":_vm.label,"value":_vm.value},on:{"change":_vm.setValue}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74abe5ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPTable/BBPSelectCell/BBPSelectCell.vue
// module id = null
// module chunks = 